import type { ErrorBoundaryProps as ExternalErrorBoundaryProps } from 'react-error-boundary'
import { ErrorBoundary as ExternalErrorBoundary } from 'react-error-boundary'

import { logError } from '@src/lib/log'

type ErrorBoundaryProps = ExternalErrorBoundaryProps & {
  children: React.ReactNode
}

export type ErrorBoundaryErrorHandler = ExternalErrorBoundaryProps['onError']

/**
 * ErrorBoundary is a wrapper around react-error-boundary's ErrorBoundary.
 *
 * It provides a default onError handler that logs the error to the console and sends it to Sentry.
 *
 * If you override the onError handler, you must call the logError function yourself.
 */
function ErrorBoundary({ onError = logError, children, ...props }: ErrorBoundaryProps) {
  return (
    <ExternalErrorBoundary {...props} onError={onError}>
      {children}
    </ExternalErrorBoundary>
  )
}

export default ErrorBoundary
